import { render, staticRenderFns } from "./teacherEdit.vue?vue&type=template&id=57f7f1e3"
import script from "./teacherEdit.vue?vue&type=script&lang=js"
export * from "./teacherEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f7f1e3')) {
      api.createRecord('57f7f1e3', component.options)
    } else {
      api.reload('57f7f1e3', component.options)
    }
    module.hot.accept("./teacherEdit.vue?vue&type=template&id=57f7f1e3", function () {
      api.rerender('57f7f1e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/education/teacherEdit.vue"
export default component.exports